module.exports = __webpack_public_path__ + "static/img/bg66.993fa624.png";